__turbopack_context__.v({
  "className": "secondary_cd87dd83-module__aJIwla__className",
  "variable": "secondary_cd87dd83-module__aJIwla__variable",
});
